import { Check } from '@sparkware/app-utils';
import {CashierSessionType} from "@sparkware/uc-sdk-core";

export function isDepositSessionType(sessionType: number | string | null | undefined): boolean {
    if(Check.isNullOrUndefined(sessionType)) {
        return true;
    }

    sessionType = sessionType.toString();
    return sessionType === CashierSessionType.QuickDeposit.toString()
        || sessionType === CashierSessionType.FullCashier.toString()
        || sessionType === CashierSessionType.Deposit.toString();
}

export function isCashoutSessionType(sessionType: number | string | null | undefined): boolean {
    // cashout should be open only when session type is defined and only if is withdrawal
    if(Check.isNullOrUndefined(sessionType)) {
        return false;
    }

    sessionType = sessionType.toString();
    return sessionType === CashierSessionType.Withdraw.toString();
}